// extracted by mini-css-extract-plugin
export default {"a":"Button_a__wOyJa","primary":"Button_primary__QrAqa","big":"Button_big__FkWxK","arrow":"Button_arrow__kVkH-","disabled":"Button_disabled__RNN+R","w100":"Button_w100__dqz0d"};